<form [formGroup]="form">
  <section fxLayout="row" fxLayoutGap="8px">

    <div fxFlex="25" fxLayout="column">
      <h3 i18n>Bus splitter types</h3>
      <div fxLayout="row" fxLayoutGap="4px">

        <div fxFlex="50">

          <mat-form-field class="app-block" appearance="outline">
            <mat-label i18n>Bus box quantity</mat-label>
            <input #maxBoxesPerBus type="number" matInput formControlName="max_boxes_per_bus">
          </mat-form-field>
          <mat-error *ngIf="form.hasError('minMax')" i18n>Bus box quantity must be equal or greater than minimum
          </mat-error>
          <app-suggestion [input]="maxBoxesPerBus" [options]="[2, 4, 8]"
            (changeSelection)="form.patchValue({max_boxes_per_bus: $event})">
          </app-suggestion>
        </div>

        <div fxFlex="50">

          <mat-form-field class="app-block" appearance="outline" class="app-block">
            <mat-label i18n>Min bus box number</mat-label>
            <input #minBoxesPerBus type="number" formControlName="min_boxes_per_bus" matInput>
          </mat-form-field>
          <app-suggestion [input]="minBoxesPerBus" [options]="[2, 4, 8]"
            (changeSelection)="form.patchValue({min_boxes_per_bus: $event})">
          </app-suggestion>
        </div>

      </div>
    </div>

    <mat-divider fxFlex [vertical]="true"></mat-divider>

    <div fxFlex="25" class="unbalanced-attendance-splitter">
      <div fxLayout="row" fxLayoutGap="8px">
        <mat-card class="info-card">
          <div class="title" i18n>Unbalanced</div>
          <div class="number">1x{{unbalanced}}</div>
        </mat-card>
        <mat-card class="info-card">
          <div class="title" i18n>Attendance splitter</div>
          <div class="number">1x{{attendanceSplitter}}</div>
        </mat-card>
      </div>
    </div>

    <mat-divider fxFlex [vertical]="true"></mat-divider>

    <div fxFlex="50" class="settings">
      <h3 i18n>Splitter sections beyond bus</h3>
      <app-input-array #sectionsInput [values]="sections" (valuesChange)="sectionsChange($event)" i18n-label
        label="Section">
        <mat-error *ngIf="sectionsError" i18n>
          Bus box quantity, attendance splitter and splitter sections does not match with Access per PON
        </mat-error>
      </app-input-array>
      <app-suggestion *ngIf="sectionsInput.index != null" [options]="allowedSplitterValues"
        (changeSelection)="sections[sectionsInput.index] = $event">
      </app-suggestion>
    </div>

  </section>

  <h3 class="header-outside-section" i18n>Boxes</h3>
  <section fxLayout="row" fxLayoutGap="8px">

    <div fxFlex="75" fxLayout="column" class="settings">

      <app-input-array #boxInput fxFlex="100" [values]="boxs" [canDelete]="false" (valuesChange)="boxsChange($event)"
        i18n-label label="Box">
        <mat-error i18n *ngIf="form.get('boxArray').invalid">Fill all boxes with the allowed values</mat-error>
      </app-input-array>

      <div>
        <app-suggestion *ngIf="boxInput.index != null"
          [options]="allowedBoxValues"
          (changeSelection)="boxs[boxInput.index] = $event">
        </app-suggestion>
      </div>
    </div>
    <div>
      <mat-card class="info-card">
        <div class="title" i18n>Last box</div>
        <div class="number">{{lastBox}}</div>
      </mat-card>
    </div>

  </section>

</form>
